import React from 'react';
import { motion } from 'framer-motion';
import { NeonButton } from './NeonButton';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-8 pb-16 overflow-hidden bg-[#0B0B0B]" data-id="element-312">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-313">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-314">
          {/* Text content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-left" data-id="element-315">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.1
          }} className="text-3xl sm:text-4xl lg:text-[3.25rem] font-bold text-white mb-6 leading-[1.15] tracking-tight" data-id="element-316">
              Apaga el ruido de tu cabeza.
              <br data-id="element-317" />
              <span className="text-cyber-neon text-shadow-neon" data-id="element-318">
                Enciende tu vida social.
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.25
          }} className="text-base sm:text-lg text-gray-400 mb-10 leading-relaxed max-w-lg" data-id="element-319">
              El protocolo de 14 días para reprogramar tu sistema nervioso y
              dejar de sobrepensar cada palabra antes de decirla. Sin terapia y
              por menos de lo que cuesta un café.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} className="flex flex-col gap-4 max-w-md" data-id="element-320">
              <NeonButton size="lg" href={CHECKOUT_URL} fullWidth data-id="element-321">
                SÍ, QUIERO HACKEAR MI ANSIEDAD
              </NeonButton>

              <p className="text-[13px] text-gray-500 font-mono text-center" data-id="element-322">
                Acceso inmediato · 2 Bonos de Regalo{' '}
                <span className="text-cyber-neon/70" data-id="element-323">($47 USD)</span>
              </p>
            </motion.div>
          </motion.div>

          {/* Smartphone mockup with green glow */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.92
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.9,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative flex items-center justify-center" data-id="element-324">
            {/* Soft green glow emanating from the screen */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-325">
              <div className="w-[70%] h-[60%] bg-[#39FF14]/[0.08] rounded-full blur-[80px]" data-id="element-326"></div>
            </div>
            <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50%] h-[40%] bg-[#39FF14]/[0.05] rounded-full blur-[120px]" data-id="element-327"></div>

            <motion.img animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} src="https://cdn.magicpatterns.com/uploads/3XJEYGCu4jc1bEgF1GtnDk/heylloyd-image-1772901779611.png" alt="Social Hacker v1.0" className="relative z-10 w-full max-w-md h-auto drop-shadow-[0_0_40px_rgba(57,255,20,0.2)]" data-id="element-328" />
          </motion.div>
        </div>
      </div>
    </section>;
}